import { UserData } from "../../hooks/FirstTimeWebSrn/Websrn";

const config = [
    {"WebSrn":"1", "name":"اظهار خصوصی ښوونځی", "frontEnd": "mobile.wordquran.com","mobile":"https://attmobile.wordquran.com", "backend": "https://azharbackend.wordquran.com"}, 
    {"WebSrn":"14", "name":"لیسه عالی خصوصی نایاب شهر", "frontEnd": "mobile.wordquran.com","mobile":"https://attmobile.wordquran.com", "backend": "https://azharbackend.wordquran.com"}, 
    {"WebSrn":"7", "name":"لیسه عالی خصوصی ندای روشن", "frontEnd": "mobile.xaosoft.com","mobile":"https://attmobile.xaosoft.com", "backend": "https://nedaeroshanbackend.xaosoft.com"},
    {"WebSrn":"23", "name":"نورالدین زنگي خصوصي ښوونځی او وړکتون", "frontEnd": "jmobile.wasily.net","mobile":"https://attmobile.jamiahakeemulummat.com", "backend": "https://backend.jamiahakeemulummat.com"},
    {"WebSrn":"17", "name":"کندهار سااینس خصوصی ښوونځی", "frontEnd": "kmobile.xaosoft.com","mobile":"https://attmobile.kandaharscience.com", "backend": "https://backend.kandaharscience.com"},
    {"WebSrn":"18", "name":"المدرسة دارالفرقان للبنیات", "frontEnd": "kmobile.xaosoft.com","mobile":"https://attmobile.kandaharscience.com", "backend": "https://backend.kandaharscience.com"},
    {"WebSrn":"20", "name":"مکتب خصوصی عثمان دانش ۱", "frontEnd": "kmobile.xaosoft.com","mobile":"https://attmobile.kandaharscience.com", "backend": "https://backend.kandaharscience.com"},
    {"WebSrn":"21", "name":"مکتب خصوصی عثمان دانش ۲", "frontEnd": "kmobile.xaosoft.com","mobile":"https://attmobile.kandaharscience.com", "backend": "https://backend.kandaharscience.com"},
    {"WebSrn":"22", "name":"ویاړ دانش خصوصي ښوونځی", "frontEnd": "kmobile.xaosoft.com","mobile":"https://attmobile.kandaharscience.com", "backend": "https://backend.kandaharscience.com"},
    {"WebSrn":"22", "name":"  خصوصي ښوونځی", "frontEnd": "testmobile.xaosoft.com","mobile":"https://attmobile.wordquran.com", "backend": "https://azharbackend.wordquran.com"},
    {"WebSrn":"17", "name":"localhost", "frontEnd": "localhost","mobile":"https://attmobile.kandaharscience.com", "backend": "https://backend.kandaharscience.com"}
];

// Get selected school from localStorage or default to first one
const getSelectedSchool = () => {
    const savedSchool = localStorage.getItem('selectedSchool');
    if (savedSchool) {
        return JSON.parse(savedSchool);
    }
    return config[0];
};

// Get current host and match backend
const currentHost = window.location.hostname.replace('www.', '');
let match = config.find(item => currentHost.includes(item.frontEnd));

// If no match found, use selected school from localStorage
if (!match) {
    match = getSelectedSchool();
}

const web = match ? match.mobile : 'http://localhost:5000';
// console.log(match);

const initialState = {
    //website api's
    imageServer: `${web}/public/`,
    Login: `${web}/apk/login`,
    Web: `${web}/WebSrn`,
    // DashBoard Api's
    Fess: `${web}/apk/showFess`,
    apiLink: web,
    // Store current school config
    currentSchool: match,
    allSchools: config,
};

const Api = (state = initialState) => {
    return state;
}

export default Api;